module.exports = __webpack_public_path__ + "media/images/castlerock/hero-image-small-1f9e32ccfdcb27fd42f357c7359012a1.jpg";